export default __webpack_public_path__ + "static/media/02AW1SEP66.c35a61da.jpg";